import { getRepositoryProjectMembership, type Repository } from '../../utils/api-client/api-schemas.ts'
import type { PickableRepository } from './repository-pick-list.tsx'

/** Flattens a repository response to what the pick list shows. */
export const toPickableRepository = (repository: Repository): PickableRepository => ({
  id: repository.id,
  fullName: repository.full_name,
  type: repository.type,
  currentProjectName: getRepositoryProjectMembership(repository)?.name,
})
